import { render, staticRenderFns } from "./member_discount_setting.vue?vue&type=template&id=ffe6eab4&scoped=true&"
import script from "./member_discount_setting.vue?vue&type=script&lang=ts&"
export * from "./member_discount_setting.vue?vue&type=script&lang=ts&"
import style0 from "./member_discount_setting.vue?vue&type=style&index=0&id=ffe6eab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe6eab4",
  null
  
)

export default component.exports